import InfoIcon from "@mui/icons-material/Info";
import { Grid, InputLabel, Tooltip } from "@mui/material";
import React from "react";
import IOSSwitch from "../../../../components/IOSSwtich";

const ActivitySettings = ({ formik }) => {
  return (
    <>
      <Grid item xs={10}>
        <Grid container alignItems="center" sx={{ paddingBottom: 2 }}>
          {/* Alert Toggle */}
          <Grid item xs={4.5} textAlign={"right"}>
            <InputLabel className="input-label">
              Alert me if the client doesnt complete this activity
            </InputLabel>
          </Grid>
          <Grid item xs={0.5}>
            <Tooltip title="All assigned caregivers will receive an alert if the client doesn't mark the activity as complete five minutes after the activity is scheduled to end.">
              <InfoIcon
                fontSize="small"
                sx={{
                  marginLeft: "4px",
                  verticalAlign: "middle",
                }}
              />
            </Tooltip>
          </Grid>
          <Grid item xs={1}>
            <IOSSwitch
              sx={{ m: 1 }}
              checked={formik.values.reminder_enabled ?? false}
              onChange={(e) =>
                formik.setFieldValue("reminder_enabled", e.target.checked)
              }
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={10}>
        <Grid container alignItems="center">
          {/* Alert Toggle */}
          <Grid item xs={4.5} textAlign={"right"}>
            <InputLabel className="input-label">
              Mark this activity as a priority for the client
            </InputLabel>
          </Grid>
          <Grid item xs={0.5}>
            <Tooltip title="Save this only for the most important activities so they stand out to your client.">
              <InfoIcon
                fontSize="small"
                sx={{
                  marginLeft: "4px",
                  verticalAlign: "middle",
                }}
              />
            </Tooltip>
          </Grid>
          <Grid item xs={1}>
            <IOSSwitch
              sx={{ m: 1 }}
              checked={formik.values.is_important ?? false}
              onChange={(e) =>
                formik.setFieldValue("is_important", e.target.checked)
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ActivitySettings;
